// @flow

import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Alert from 'react-s-alert';

import App from './App.jsx';

import {no_rclick, hs_bool, takeDir, ms_regex} from './utils.js';
import {T_CULTI, T_MAV} from './codtype.js';

import type {T_Item, T_Err, T_ErrOk, T_ReportEntry, T_TrimResult} from './types.js';

import 'alertifyjs/build/css/alertify.css';
import './css/TreeItemMenu.css';

const alertify = require('alertifyjs');



type T_ItemMenuProps = {
  px  : number,
  py  : number,
  node: T_Item,
  app : App,
};



export default class TreeItemMenu extends Component<T_ItemMenuProps> {
  componentDidMount() {
    this.props.app.tree_item_menu = this;
  }
  close      : () => void;
  change_item: (ev: SyntheticEvent<*>, value: string) => void;
  
  
  constructor(props: T_ItemMenuProps) {
    super(props);
    this.change_item = this.change_item.bind(this);
    this.close       = this.close.bind(this);
    
  }
  
  
  
  componentWillUnmount() {
    this.props.app.tree_item_menu = null;
  }
  
  
  
  componentDidUpdate(prevProps: T_ItemMenuProps) {
    if (this.props.node.Path !== prevProps.node.Path) {
      this.remove_hilight(prevProps.node);
    }
  }
  
  
  
  remove_hilight(node: T_Item): void {
    const item = this.props.app.get_item_any(node.Path);
    
    if (item != null) {
      item.setState({hilight_fm: false});
    }
  }
  
  
  
  close = (): void => {
    this.remove_hilight(this.props.node);
    
    this.props.app.setState({tree_item_menu: null});
  };
  
  
  
  reporte_predios(path: string, recreate: boolean): void {
    const {app} = this.props,
          url   = `${app.remote}/index-of-program/?dir=${path}&recreate=${hs_bool(recreate)}&session_id=${app.session()}`;
    
    this.close();    // NOTE: Hay que cerrar lo antes posible.
    
    fetch(url).then(resp => resp.json()).then((response: Array<T_ReportEntry> | T_Err) => {
      if (response.error && typeof response.error === 'string') {
        return Alert.error(response.error);
      }
      else if (response instanceof Array) {
        app.setState({
          report_entries: {entries: response, path}
        });
      }
    });
  }

  //descarga de reportes de reportes 
  down_diagnostico(path: String): void {
    const {app} = this.props,
     urls=`${app.remote}/get-pdf/?path=${path}/marcos_friedl_diagnostico.pdf&session_id=${app.session()}`
     console.log(app)
    
    
    fetch(urls).then(resp => resp.blob()).then(resp => {
      
      const file = new Blob([resp], {type:"application/pdf"});
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href=fileURL
      link.download="Reporte_de_Diagnostico.pdf"
      link.click();

    })

  }
  down_monitoreo(path: String): void {
    const {app} = this.props,
     urls=`${app.remote}/get-pdf/?path=${path}/marcos_friedl_monitoreo.pdf&session_id=${app.session()}`
     console.log(app)
    
    
    fetch(urls).then(resp => resp.blob()).then(resp => {
      
      const file = new Blob([resp], {type:"application/pdf"});
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href=fileURL
      link.download="Reporte_de_Monitoreo.pdf"
      link.click();

    })

  }
  
  
  
  create_dir(path: String): JSX.Element {
    const { app } = this.props;
    
    app.setState({ 
      show_collect_mkdir: true,
      collect_mkdir_path: path
    });
    
    this.close();
  };
  
  
  
  recortar_mapas(path: string): void {
    const {app} = this.props,
          url   = `${app.remote}/recortar-mapas/?culti=${path}&session_id=${app.session()}`;
    
    this.close();    // NOTE: Hay que cerrar lo antes posible.
    
    fetch(url).then(resp => resp.json()).then((response: T_TrimResult) => {
      if (response.error && typeof response.error === 'string') {
        Alert.error(response.error);
      }
      else if (response.ok && typeof response.ok === 'string') {
        Alert.error(`${response.ok}${response.need_recalc ? ' Recalcule las estadísticas' : ''}`);
      }
    });
  }
  
  
  
  delete_dir(node: T_Item): void {
    const
      {app} = this.props,
      path  = node.Path,
      url   = `${app.remote}/new-remove-dir/?dir=${path}&session_id=${app.session()}`;
    
    this.close();    // NOTE: Hay que cerrar lo antes posible.
    
    fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
      if (response.error && typeof response.error === 'string') {
        Alert.error(response.error);
      }
      else if (response.ok && typeof response.ok === 'string') {        
        app.reload_dir(takeDir(path), (resp) => {
          Alert.success('La carpeta fue borrada exitosamente.');
        });
      }
    });
  }
  
  
  
  delete_file(node: T_Item): void {
    const
      {app} = this.props,
      path  = node.Path,
      url   = `${app.remote}/remover-archivos/?path=${path}&session_id=${app.session()}`;
    
    this.close();    // NOTE: Hay que cerrar lo antes posible.
    
    fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
      if (response.error && typeof response.error === 'string') {
        Alert.error(response.error);
      }
      else if (response.ok && typeof response.ok === 'string') {        
        const alerta = response.ok;
         
        const end = () => {
          app.reload_dir(takeDir(path), (resp) => {
            Alert.success(alerta);
          });
        };
        
        const clean_up = () => {
          if (node.Cod === T_MAV) {
            app.map_ui.setState({show_mav: false, mav_detail: null, zombie_mav: null}, end);
          }
          else if (node.Type === 'png' && node.File.indexOf('Mapa_Tematico_') === 0) {
            app.close_mt_view(end);
          }
          else if (node.Type === 'obs') {
            if (app.state.obs != null) {
              const item_obs = app.get_item_obs(app.state.obs.path);
              
              app.setState({obs: null});
              
              if (item_obs != null) {
                item_obs.close(end);
              }
              else {
                end();
              }
            }
            else {
              end();
            }
          }
          else {
            end();
          }
        };
        
        const item = app.get_item_any(path);
        
        if (item != null) {
          item.close(clean_up);
        }
        else {
          clean_up();
        }
      }
    });
  }
  
  
  
  delete_file_ask(node: T_Item): void {
    alertify.confirm('Borrar', `¿Desea borrar el archivo ${node.label}?`, () => this.delete_file(node), this.close);
  }
  
  
  
  delete_dir_ask(node: T_Item): void {
    alertify.confirm('Borrar', `¿Desea borrar la carpeta ${node.label}?`, () => this.delete_dir(node), this.close);
  }
  
  
  
  download_png_kmz(path: string): void {
    const {app} = this.props;
    
    app.make_link(`${app.remote}/get-png-as-kmz/?path=${path}&session_id=${app.session()}`);
    
    this.close();
  }
  
  
  
  change_item = (ev: SyntheticEvent<*>, value: string): void => {
    const {node} = this.props,
          {Path} = node;
    
    if (value === 'reporte') {
      this.reporte_predios(Path, Path !== '/MAPS');
    }
    else if (value === 'mkdir'){
      this.create_dir(Path);  
    }
    else if (value === 'clip') {
      this.recortar_mapas(Path);
    }
    else if (value === 'remover') {
      this.delete_file_ask(node);
    }
    else if (value === 'rm_dir') {
      this.delete_dir_ask(node);
    }
    else if (value === 'png_kmz') {
      this.download_png_kmz(Path);
    }
    else if (value === 'descargaDiagnostico'){
      this.down_diagnostico(Path);
    }
    else if (value === 'descargaMonitoreo'){
      this.down_monitoreo(Path);
    }
  };


  
  
  
  render() {
    const {Type, Cod, File, Path} = this.props.node,
          is_dir   = Type === 'dir' && Path !== '/MAPS',
          is_obs   = Type === 'obs',
          is_png   = Type === 'png',
          is_culti = Cod  === T_CULTI,
          is_mav   = Cod  === T_MAV,
          is_diffx = (is_png   && File.startsWith('diff_')) ||
                     (is_culti && Path.indexOf('/Mapas_Diferenciales/cultivable_') !== -1) ||
                     (is_dir   && Path.endsWith('/Mapas_Diferenciales')),
          is_mt    = is_png && File.indexOf('Mapa_Tematico_') === 0,
          is_ms    = File.match(ms_regex) && File.indexOf('ms_0000') === -1;
    
    // ! VALIDAR QUE SEA COORDINADOR o más
    /* COLLECt */
    const { user } = this.props.app.props,
      c_roles = [9, 10, 12, 14, 15],
      has_access = c_roles.includes(user.id_rol),
      is_tepeyac = Path.includes('/MAPS/Tepeyac'),
      is_agrosat = Path.includes('MAPS/agrosat_internacional/anagra/x_anagra'),
      s_PATH = Path.split('/').length,
      is_collect = s_PATH >= 3 && s_PATH <= 4;
    /*  */

    if (is_dir || is_culti || is_mav || is_png || is_obs || is_ms) {
      const pos = {style: {left: this.props.px, top: this.props.py, zIndex: 1000000}},
            sty = {fontSize: 13, width: 180};
      
      return (
        <Paper className='float_menu' {...pos}>
          <Menu onChange={this.change_item} desktop={true} style={{maxWidth: 180}}>
            {is_dir && !is_agrosat &&
              <MenuItem style={sty} value='reporte' primaryText='Reporte de predios' onContextMenu={no_rclick} />
            }

            {has_access && is_dir && is_tepeyac && is_collect &&
              <MenuItem style={sty} value='mkdir' primaryText='Crear ruta' onContextMenu={no_rclick} />
            }
            
            {is_culti &&
              <MenuItem style={sty} value='clip' primaryText='Recortar mapas' onContextMenu={no_rclick} />
            }
            
            {is_png &&
              <MenuItem style={sty} value='png_kmz' primaryText='Descargar Kmz' onContextMenu={no_rclick} />
            }
            
            {(is_mav || is_mt || is_obs || is_diffx) &&
              <MenuItem style={sty} value={is_dir ? 'rm_dir' : 'remover'} primaryText='Eliminar' onContextMenu={no_rclick} />
            }
            {(has_access && is_dir && is_agrosat) &&
              <MenuItem style={sty} value='descargaDiagnostico' primaryText='Reporte de Diagnóstico' onContextMenu={no_rclick}/>
              
            } 
            {(has_access && is_dir && is_agrosat) &&
              <MenuItem style={sty} value='descargaMonitoreo' primaryText='Reporte de Monitoreo' onContextMenu={no_rclick}/>
              
            } 

          </Menu>
          
        </Paper>
       
        
      );
    }
    
    else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/TreeItemMenu.jsx